var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfilledStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2614 16.5733L12.0008 16.4141L11.7402 16.5733L6.88824 19.5369L8.20741 14.0066L8.27827 13.7096L8.04633 13.5109L3.72848 9.81216L9.39573 9.35782L9.70015 9.33342L9.81743 9.05143L12.0008 3.80199L14.1841 9.05143L14.3014 9.33342L14.6058 9.35782L20.2732 9.81216L15.9553 13.5109L15.7234 13.7096L15.7942 14.0066L17.1134 19.5369L12.2614 16.5733Z",
    fill: "white",
    stroke: "#F0DC96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilledStart);
export default __webpack_public_path__ + "static/media/unfilledStart.f4261faf4084e4fb1e6e5bcf4a21ce2c.svg";
export { ForwardRef as ReactComponent };